import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import { setModoTela, initForm } from './veiculoTipoConsumoActions';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';

class VeiculoTipoConsumoForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='id_veiculo_tipo'
								component={Select}
								options={this.props.listaVeiculoTipo}
								label='Tipo do Veículo'
								cols='12 12 12 12'
								placeholder='Selecione o tipo do veículo'
								readOnly={readOnly} />

							<Field
								name='meta'
								component={LabelAndInputNumber}
								label='Meta' placeholder='Informe a meta'
								cols='12 12 12 12'
								casas={2}
								readOnly={readOnly} />
								
							<Field
								name='premio'
								component={LabelAndInputNumber}
								label='Prêmio' placeholder='Informe o prêmio'
								cols='12 12 12 12'
								casas={2}
								readOnly={readOnly} />
								
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

VeiculoTipoConsumoForm = reduxForm({form: 'veiculoTipoConsumoForm', destroyOnUnmount: false})(VeiculoTipoConsumoForm);
const mapStateToProps = state => ({
	sessao: state.auth.veiculoTipoConsumo,
	formularioValues: getFormValues('veiculoTipoConsumoForm')(state),
	registro: state.veiculoTipoConsumo.registro,
	listaVeiculoTipo: state.veiculoTipoConsumo.listaVeiculoTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VeiculoTipoConsumoForm);
